var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHealthAndBeautyHighEnd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Make-Up-Mirror-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Make Up Mirror 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.68 5.85A7.52 7.52 0 0 0 6 10.7a1 1 0 0 0 0.6 1.3 0.79 0.79 0 0 0 0.3 0.05 1 1 0 0 0 1 -0.7 5.49 5.49 0 0 1 3.46 -3.55 1 1 0 0 0 -0.64 -1.9Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66 17.5h2.27a0.51 0.51 0 0 0 0.44 -0.26 0.5 0.5 0 0 0 0 -0.5A9 9 0 1 1 21 12a8.93 8.93 0 0 1 -1.36 4.74 0.5 0.5 0 0 0 0 0.5 0.51 0.51 0 0 0 0.44 0.26h2.27a0.49 0.49 0 0 0 0.45 -0.28A11.89 11.89 0 0 0 24 12a12 12 0 0 0 -24 0 11.89 11.89 0 0 0 1.21 5.22 0.49 0.49 0 0 0 0.45 0.28Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 19h-6.29a1 1 0 0 0 -0.71 0.29l-1.56 1.56a0.47 0.47 0 0 1 -0.35 0.15H9.91a0.47 0.47 0 0 1 -0.35 -0.15L8 19.29a1 1 0 0 0 -0.71 -0.29H1a1 1 0 0 0 -1 1v0.5C0 22.72 1.64 24 4.5 24h15c2.86 0 4.5 -1.28 4.5 -3.5V20a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHealthAndBeautyHighEnd);
export default ForwardRef;